@if (showHeader()) {
<app-header></app-header>
}
<div class="content-container">
    <router-outlet></router-outlet>
</div>
<app-voice-load-dialog></app-voice-load-dialog>